'use client';

import {
  createContext,
  useContext,
  type ReactNode,
} from 'react';
import type { ButtonPreset } from '@/constants/componentPresets';
import type { Temper } from '@/types/frontend-types';

export interface ShowMessageModalOptions {
  temper: Temper;
  title: string;
  titleNode?: ReactNode;
  hackerAllCaps?: boolean;
  body?: string;
  children?: ReactNode;
  footerNote?: string;
  primaryButtonText?: string;
  primaryButtonPreset?: ButtonPreset;
  secondaryButtonText?: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  onClose?: () => void;
  disableDismiss?: boolean;
  closeOnPrimary?: boolean;
  closeOnSecondary?: boolean;
  loading?: boolean;
  primaryLoading?: boolean;
}

export interface MessageModalContextType {
  showMessageModal: (options: ShowMessageModalOptions) => void;
  hideMessageModal: () => void;
  visible: boolean;
}

export const MessageModalContext =
  createContext<MessageModalContextType | null>(null);

export function useMessageModal(): MessageModalContextType {
  const context = useContext(MessageModalContext);
  if (!context) {
    throw new Error('useMessageModal must be used within a MessageModalProvider');
  }
  return context;
}
